import styled, { css } from "styled-components";
import getBorderColor from "../../../utils/getBorderColor";
import getBorderRadius from "../../../utils/getBorderRadius";
import getColor from "../../../utils/getColor";
import space from "../../../utils/space";
import unit from "../../../utils/unit";
import AnimateHeightOrg from "../../organisms/AnimateHeightOrg";
export var Wrapper = styled.div.withConfig({
  componentId: "sc-65rhr3-0"
})(function (_ref) {
  var $hasOnClick = _ref.$hasOnClick,
    theme = _ref.theme;
  return css(["display:grid;background-color:", ";border:", " solid ", ";border-radius:", ";padding:", " ", " ", " ", ";", ""], getColor(theme, "background"), unit(1), getBorderColor(theme, "backgroundLight", "extraLow"), getBorderRadius(theme, "xlarge"), space(1.5), space(1.5), space(1.5), space(3), $hasOnClick ? css(["cursor:pointer;&:hover{background-color:", ";}"], getColor(theme, "backgroundDarkLight")) : null);
});
export var ExpandedContent = styled(AnimateHeightOrg).withConfig({
  componentId: "sc-65rhr3-1"
})(["> *:first-child{padding-top:", ";}"], space(3));